
    <div class="dropdown-width justify-end">
        <mat-form-field appearance="outline">
            <mat-select id="otherPageOptions" [formControl]="otherPageOptions">
                <mat-option class="optionHeight" value=0>{{'REVIEW_SOL_OTHER_TAB.LABOR_BY_LEVEL' | translate}}</mat-option>
                <mat-option class="optionHeight" value=1>{{'REVIEW_SOL_OTHER_TAB.TASK_BY_LEVEL' | translate}}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>

<div *ngIf="otherPageOptions.value == 0">
    <app-sol-labor-by-level></app-sol-labor-by-level>

</div>
<div *ngIf="otherPageOptions.value == 1">
    <app-sol-task-by-level></app-sol-task-by-level>

</div>
